<template>
  <router-view /> 
</template>
<script> 

  export default {
    name: '', 
  }
</script>
<style lang="scss">
  html,
  body {
    margin: 0;
    padding: 0;
  }
  img{
    max-width: 100%;
  }
  *::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 6px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 6px;
  }
  *::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius   : 6px;
    background-color: #ccc;
  }
  *::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    background   : #ededed;
    border-radius: 10px;
  }
  .el-table th.el-table__cell {
    background-color: #e8eaee !important;
    border-color: #d7dbe1 !important;
    color: #3c4353;
  }
  textarea{
    font-family: unset;
  }


  /* 修改为你想要的颜色 */
  :root {
    // --el-color-primary: #23c2f3 !important;
  }

  .form_tip{
    font-size: 12px;
    color: #aaa;
    line-height: 1.2;
  }
</style>